module.exports = __webpack_public_path__ + "img/logo22.f6a0937e.png";